import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3e258a5b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 2
};
const _hoisted_5 = {
  key: 3
};
const _hoisted_6 = {
  key: 4
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  key: 3
};
const _hoisted_14 = {
  key: 4
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  key: 2
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 2
};
const _hoisted_20 = {
  key: 3
};
const _hoisted_21 = {
  key: 4
};
const _hoisted_22 = {
  key: 3
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 1
};
const _hoisted_25 = {
  key: 2
};
const _hoisted_26 = {
  key: 3
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 4
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 1
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  key: 1
};
const _hoisted_33 = {
  key: 2
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ": ", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1));
const _hoisted_36 = {
  key: 3
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  key: 5
};
const _hoisted_39 = {
  key: 0
};
const _hoisted_40 = {
  key: 1
};
const _hoisted_41 = {
  key: 0
};
const _hoisted_42 = {
  key: 1
};
const _hoisted_43 = {
  key: 2
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, ": ", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1));
const _hoisted_46 = {
  key: 3
};
const _hoisted_47 = {
  key: 0
};
const _hoisted_48 = {
  key: 6
};
const _hoisted_49 = {
  key: 0
};
const _hoisted_50 = {
  key: 0
};
const _hoisted_51 = {
  key: 1
};
const _hoisted_52 = {
  key: 1
};
const _hoisted_53 = {
  key: 2
};
const _hoisted_54 = {
  key: 3
};
const _hoisted_55 = {
  key: 4
};
const _hoisted_56 = {
  key: 0
};
const _hoisted_57 = {
  key: 7
};
const _hoisted_58 = {
  key: 0
};
const _hoisted_59 = {
  key: 0
};
const _hoisted_60 = {
  key: 1
};
const _hoisted_61 = {
  key: 2
};
const _hoisted_62 = {
  key: 3
};
const _hoisted_63 = {
  key: 4
};
const _hoisted_64 = {
  key: 5
};
const _hoisted_65 = {
  key: 0
};
const _hoisted_66 = {
  key: 8
};
const _hoisted_67 = {
  key: 0
};
const _hoisted_68 = {
  key: 1
};
const _hoisted_69 = {
  key: 2
};
const _hoisted_70 = {
  key: 9
};
const _hoisted_71 = {
  key: 0
};
const _hoisted_72 = {
  key: 1
};
const _hoisted_73 = {
  key: 2
};
const _hoisted_74 = {
  key: 10
};
const _hoisted_75 = {
  key: 0
};
const _hoisted_76 = {
  key: 1,
  style: {
    "cursor": "pointer"
  }
};
const _hoisted_77 = {
  key: 2
};
const _hoisted_78 = {
  key: 3
};
const _hoisted_79 = {
  key: 4
};
const _hoisted_80 = {
  key: 0
};
const _hoisted_81 = {
  key: 11
};
const _hoisted_82 = {
  key: 0
};
const _hoisted_83 = {
  key: 1
};
const _hoisted_84 = {
  key: 2
};
const _hoisted_85 = {
  key: 0
};
const _hoisted_86 = {
  key: 0,
  class: "scTable-page"
};
const _hoisted_87 = {
  class: "scTable-pagination"
};
const _hoisted_88 = {
  key: 0,
  class: "scTable-do"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_solt = _resolveComponent("solt");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_button = _resolveComponent("el-button");
  const _component_columnSetting = _resolveComponent("columnSetting");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_form = _resolveComponent("el-form");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "scTable",
    style: _normalizeStyle({
      'height': $options._height
    }),
    ref: "scTableMain"
  }, [_createElementVNode("div", {
    class: "scTable-table",
    style: _normalizeStyle({
      'height': $options._table_height
    })
  }, [(_openBlock(), _createBlock(_component_el_table, _mergeProps({
    id: "scTable"
  }, _ctx.$attrs, {
    data: $data.tableData,
    "row-key": $props.rowKey,
    key: $data.toggleIndex,
    ref: "scTable",
    style: {
      "width": "100%"
    },
    height: $props.height == 'auto' ? null : '100%',
    size: $data.config.size,
    border: $data.config.border,
    stripe: $data.config.stripe,
    "summary-method": $props.remoteSummary ? $options.remoteSummaryMethod : $props.summaryMethod,
    onSortChange: $options.sortChange,
    onFilterChange: $options.filterChange
  }), {
    empty: _withCtx(() => [_createVNode(_component_el_empty, {
      description: $data.emptyText,
      "image-size": 100
    }, null, 8, ["description"])]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.userColumn, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: index
      }, [!item.hide ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 0,
        "column-key": item.prop,
        prop: item.prop,
        label: item.label,
        width: item.width,
        sortable: item.sortable,
        fixed: item.fixed,
        "show-overflow-tooltip": item.showOverflowTooltip
      }, {
        default: _withCtx(scope => [item.table === 'order' ? (_openBlock(), _createElementBlock("span", _hoisted_1, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type !== 'obj' && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'goods_type' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($data.packageTypeObj[scope.row[item.prop]]), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'status' ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.statusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'operate_type' && $data.operateTypeObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.operateTypeObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [item.type === 'obj' && item.prop2 === 'sell_product_id' && scope.row[item.prop] && scope.row[item.prop][item.prop2] && $data.sellProductObj[scope.row[item.prop][item.prop2]] ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row && scope.row[item.prop] ? $data.sellProductObj[scope.row[item.prop][item.prop2]].name : '-'), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row && scope.row[item.prop] ? scope.row[item.prop][item.prop2] : '-'), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'waybill' ? (_openBlock(), _createElementBlock("span", _hoisted_9, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type !== 'obj' && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'goods_type' ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($data.packageTypeObj[scope.row[item.prop]]), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'status' ? (_openBlock(), _createElementBlock("span", _hoisted_13, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), item.prop === 'sell_product_id' && scope.row[item.prop] && scope.row[item.prop] && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'entry' ? (_openBlock(), _createElementBlock("span", _hoisted_16, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [item.type === 'image' ? (_openBlock(), _createElementBlock("span", _hoisted_17, [_createVNode(_component_el_image, {
            src: scope.row[item.prop],
            "preview-teleported": "true",
            "preview-src-list": [scope.row[item.prop]],
            size: "small",
            style: {
              "cursor": "pointer",
              "width": "40px",
              "height": "40px"
            },
            "hide-on-click-modal": ""
          }, null, 8, ["src", "preview-src-list"])])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), item.type === 'obj' ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($data.unitObj[scope.row[item.prop]]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'tag' ? (_openBlock(), _createElementBlock("span", _hoisted_21, [_createVNode(_component_el_tag, {
            style: {
              "cursor": "pointer"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row[item.prop]), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'track' ? (_openBlock(), _createElementBlock("span", _hoisted_22, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'status' ? (_openBlock(), _createElementBlock("span", _hoisted_25, [scope.row[item.prop] <= 2 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 3 || scope.row[item.prop] === 4 || scope.row[item.prop] === 5 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 6 || scope.row[item.prop] === 7 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] > 7 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 3,
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.row[item.prop] && item.prop === 'sell_product_id' && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'feeTrail' ? (_openBlock(), _createElementBlock("span", _hoisted_28, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'obj' && item.label === '时效' ? (_openBlock(), _createElementBlock("span", _hoisted_30, [_createElementVNode("span", null, _toDisplayString(scope.row[item.prop].start_week), 1), scope.row[item.prop].start_week ? (_openBlock(), _createElementBlock("span", _hoisted_31, " ~ ")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(scope.row[item.prop].end_week), 1), scope.row[item.prop].end_week ? (_openBlock(), _createElementBlock("span", _hoisted_32, " 工作日")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'obj' && item.prop === 'otherprice' ? (_openBlock(), _createElementBlock("span", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row[item.prop], i => {
            return _openBlock(), _createElementBlock("span", {
              key: i.fund_type_id
            }, [_createElementVNode("span", null, _toDisplayString($data.transportFundTypesObj[i.fund_type_id]), 1), _hoisted_34, _createElementVNode("span", null, _toDisplayString(i.real_account), 1), _hoisted_35]);
          }), 128))])) : _createCommentVNode("", true), scope.row[item.prop] && item.prop === 'sell_product_id' && scope.row[item.prop] && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'sellPrice' ? (_openBlock(), _createElementBlock("span", _hoisted_38, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'obj' && item.label === '时效' ? (_openBlock(), _createElementBlock("span", _hoisted_40, [_createElementVNode("span", null, _toDisplayString(scope.row[item.prop].start_week), 1), scope.row[item.prop].start_week ? (_openBlock(), _createElementBlock("span", _hoisted_41, " ~ ")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(scope.row[item.prop].end_week), 1), scope.row[item.prop].end_week ? (_openBlock(), _createElementBlock("span", _hoisted_42, " 工作日")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'obj' && item.prop === 'otherprice' ? (_openBlock(), _createElementBlock("span", _hoisted_43, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row[item.prop], i => {
            return _openBlock(), _createElementBlock("span", {
              key: i.fund_type_id
            }, [_createElementVNode("span", null, _toDisplayString($data.transportFundTypesObj[i.fund_type_id]), 1), _hoisted_44, _createElementVNode("span", null, _toDisplayString(i.real_account), 1), _hoisted_45]);
          }), 128))])) : _createCommentVNode("", true), scope.row[item.prop] && item.prop === 'sell_product_id' && scope.row[item.prop] && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'payOrder' ? (_openBlock(), _createElementBlock("span", _hoisted_48, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [item.type === 'num' ? (_openBlock(), _createElementBlock("span", _hoisted_49, [scope.row.paid_receivable ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString($options.minus(scope.row.receivable, scope.row.paid_receivable)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(scope.row.receivable), 1))])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type !== 'obj' && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'goods_type' ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString($data.packageTypeObj[scope.row[item.prop]]), 1)) : _createCommentVNode("", true), item.prop === 'sell_product_id' && scope.row[item.prop] && scope.row[item.prop] && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'freight' ? (_openBlock(), _createElementBlock("span", _hoisted_57, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [item.type === 'num' ? (_openBlock(), _createElementBlock("span", _hoisted_58, [scope.row.paid_receivable ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(scope.row.paid_receivable), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'obj' && item.prop === 'status' ? (_openBlock(), _createElementBlock("span", _hoisted_60, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type !== 'obj' && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), item.type === 'obj' && item.prop === 'goods_type' ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString($data.packageTypeObj[scope.row[item.prop]]), 1)) : _createCommentVNode("", true), item.prop === 'sell_product_id' && scope.row[item.prop] && scope.row[item.prop] && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'send' ? (_openBlock(), _createElementBlock("span", _hoisted_66, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [item.type === 'image' ? (_openBlock(), _createElementBlock("span", _hoisted_67, [_createVNode(_component_el_image, {
            src: scope.row[item.prop],
            "preview-teleported": "true",
            "preview-src-list": [scope.row[item.prop]],
            size: "small",
            style: {
              "cursor": "pointer",
              "width": "40px",
              "height": "40px"
            },
            "hide-on-click-modal": ""
          }, null, 8, ["src", "preview-src-list"])])) : _createCommentVNode("", true), item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), item.type === 'switch' ? (_openBlock(), _createElementBlock("span", _hoisted_69, [_createVNode(_component_el_switch, {
            "model-value": scope.row[item.prop] === 1 ? true : false,
            style: {
              "z-index": "9999"
            },
            loading: _ctx.isDefault,
            size: "large",
            "inline-prompt": "",
            "active-text": "是",
            "inactive-text": "否",
            onClick: $event => $options.clickDefaultAddress(scope)
          }, null, 8, ["model-value", "loading", "onClick"])])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row[item.prop2] ? scope.row[item.prop2] : scope.row[item.prop]), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'receive' ? (_openBlock(), _createElementBlock("span", _hoisted_70, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [item.type === 'image' ? (_openBlock(), _createElementBlock("span", _hoisted_71, [_createVNode(_component_el_image, {
            src: scope.row[item.prop],
            "preview-teleported": "true",
            "preview-src-list": [scope.row[item.prop]],
            size: "small",
            style: {
              "cursor": "pointer",
              "width": "40px",
              "height": "40px"
            },
            "hide-on-click-modal": ""
          }, null, 8, ["src", "preview-src-list"])])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_72, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), item.type === 'switch' ? (_openBlock(), _createElementBlock("span", _hoisted_73, [_createVNode(_component_el_switch, {
            "model-value": scope.row[item.prop] === 1 ? true : false,
            style: {
              "z-index": "9999"
            },
            loading: _ctx.isDefault,
            size: "large",
            "inline-prompt": "",
            "active-text": "是",
            "inactive-text": "否",
            onClick: $event => $options.clickDefaultAddress2(scope)
          }, null, 8, ["model-value", "loading", "onClick"])])) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(scope.row[item.prop2] ? scope.row[item.prop2] : scope.row[item.prop]), 1)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'issueList' ? (_openBlock(), _createElementBlock("span", _hoisted_74, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'obj' && item.prop === 'status' ? (_openBlock(), _createElementBlock("span", _hoisted_75, [scope.row[item.prop] <= 2 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 3 || scope.row[item.prop] === 4 || scope.row[item.prop] === 5 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 6 || scope.row[item.prop] === 7 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] > 7 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 3,
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.trackStatusObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.type === 'click' ? (_openBlock(), _createElementBlock("span", _hoisted_76, [!scope.row[item.prop] ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            onClick: $event => $options.showProblem(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.clickVal), 1)]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_tag, {
            key: 1
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row[item.prop]), 1)]),
            _: 2
          }, 1024))])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type !== 'obj' && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true), item.prop === 'sell_product_id' && scope.row[item.prop] && scope.row[item.prop] && $data.sellProductObj[scope.row[item.prop]] ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString($data.sellProductObj[scope.row[item.prop]].name), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_80, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), item.table === 'billStat' ? (_openBlock(), _createElementBlock("span", _hoisted_81, [!item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 0
        }, {
          default: _withCtx(() => [scope.row[item.prop] && item.type === 'obj' && item.prop === 'status' ? (_openBlock(), _createElementBlock("span", _hoisted_82, [scope.row[item.prop] === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 0,
            type: "info"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.billStatObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 1,
            type: "danger"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.billStatObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 2 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 2,
            type: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.billStatObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), scope.row[item.prop] === 3 ? (_openBlock(), _createBlock(_component_el_tag, {
            key: 3,
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.billStatObj[scope.row[item.prop]]), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(scope.row[item.prop]), 1)) : _createCommentVNode("", true), scope.row[item.prop] && item.type === 'time' ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString($options.formatDate(scope.row[item.prop])), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true), item.prop2 ? (_openBlock(), _createBlock(_component_solt, {
          key: 1
        }, {
          default: _withCtx(() => [scope.row[item.prop] ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(scope.row[item.prop][item.prop2]), 1)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["column-key", "prop", "label", "width", "sortable", "fixed", "show-overflow-tooltip"])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 3
  }, 16, ["data", "row-key", "height", "size", "border", "stripe", "summary-method", "onSortChange", "onFilterChange"]))], 4), !$props.hidePagination || !$props.hideDo ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [!$props.hidePagination ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 0,
    background: "",
    small: true,
    layout: $props.paginationLayout,
    total: $data.total,
    "page-size": $data.scPageSize,
    "page-sizes": $props.pageSizes,
    currentPage: $data.currentPage,
    "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => $data.currentPage = $event),
    onCurrentChange: $options.paginationChange,
    "onUpdate:pageSize": $options.pageSizeChange
  }, null, 8, ["layout", "total", "page-size", "page-sizes", "currentPage", "onCurrentChange", "onUpdate:pageSize"])) : _createCommentVNode("", true)]), !$props.hideDo ? (_openBlock(), _createElementBlock("div", _hoisted_88, [!$props.hideRefresh ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: $options.refresh,
    icon: "el-icon-refresh",
    circle: "",
    style: {
      "margin-left": "15px"
    }
  }, null, 8, ["onClick"])) : _createCommentVNode("", true), $props.column ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 1,
    placement: "top",
    title: "列设置",
    width: 500,
    trigger: "click",
    "hide-after": 0,
    onShow: _cache[1] || (_cache[1] = $event => $data.customColumnShow = true),
    onAfterLeave: _cache[2] || (_cache[2] = $event => $data.customColumnShow = false)
  }, {
    reference: _withCtx(() => [_createVNode(_component_el_button, {
      icon: "el-icon-set-up",
      circle: "",
      style: {
        "margin-left": "15px"
      }
    })]),
    default: _withCtx(() => [$data.customColumnShow ? (_openBlock(), _createBlock(_component_columnSetting, {
      key: 0,
      ref: "columnSetting",
      onUserChange: $options.columnSettingChange,
      onSave: $options.columnSettingSave,
      onBack: $options.columnSettingBack,
      column: $data.userColumn
    }, null, 8, ["onUserChange", "onSave", "onBack", "column"])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), !$props.hideSetting ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 2,
    placement: "top",
    title: "表格设置",
    width: 400,
    trigger: "click",
    "hide-after": 0
  }, {
    reference: _withCtx(() => [_createVNode(_component_el_button, {
      icon: "el-icon-setting",
      circle: "",
      style: {
        "margin-left": "15px"
      }
    })]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      "label-width": "80px",
      "label-position": "left"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "表格尺寸"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.config.size,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.config.size = $event),
          size: "small",
          onChange: $options.configSizeChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_button, {
            label: "large"
          }, {
            default: _withCtx(() => [_createTextVNode("大")]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: "default"
          }, {
            default: _withCtx(() => [_createTextVNode("正常")]),
            _: 1
          }), _createVNode(_component_el_radio_button, {
            label: "small"
          }, {
            default: _withCtx(() => [_createTextVNode("小")]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onChange"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "样式"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          modelValue: $data.config.border,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.config.border = $event),
          label: "纵向边框"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
          modelValue: $data.config.stripe,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.config.stripe = $event),
          label: "斑马纹"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 4)), [[_directive_loading, $data.loading]]);
}